import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import { CapisDepartamento, CapiSeleccionado, DetallesCapis } from '../utils/utils';
import logoPrivadas from "../assets/images/ubicacionPrivadas.png"
import logoPatronales from "../assets/images/ubicacionPatronales.png"
import logoPublicas from "../assets/images/ubicacionPublicas.png"
import { Link, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faXmark } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-modal';
import MyMap from '../components/myMap';

function DetallesDepto() {

	const { id } = useParams()
	const [capis, setCapis] = useState([]);
	const [capisDepto, setCapisDepto] = useState([]);
	const [selectedPosition, setSelectedPosition] = useState(null)
	const [loading, setLoading] = useState(id ? true : false)
	const [selectedCapi, setSelectedCapi] = useState(null);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [search, setSearch] = useState('');
	const [tipoNaturaleza, setTipoNaturaleza] = useState('');

	// async function getCapis() {
	//   let capis = await DetallesCapis();
	//   console.log(capis);
	//   setCapis(capis);
	// }

	useEffect(() => {
		allFunctions();
	}, []);

	async function getCapisDepto() {
		let capisDepto = await CapisDepartamento(id);
		setCapisDepto(capisDepto);
	}

	async function getSelectedCapi(id_autorizacion) {
		console.log("Cargando detalles del CAPI:", id_autorizacion); // Verificar ID
		let selectedCapi = await CapiSeleccionado(id_autorizacion);
		console.log("Detalles obtenidos:", selectedCapi); // Verificar datos recibidos
		setSelectedCapi(selectedCapi);
		setIsModalOpen(true);
	}

	useEffect(() => {
		console.log("selectedCapi actualizado:", selectedCapi);
	}, [selectedCapi]);

	const allFunctions = async () => {
		setCapis(await DetallesCapis());
		setLoading(true);
		if (id) {
			await getCapisDepto();
		}
		setLoading(false)
	}

	const icons = {
		Privado: L.icon({
			iconUrl: logoPrivadas,
			iconSize: [38, 38],
		}),
		Patronal: L.icon({
			iconUrl: logoPatronales,
			iconSize: [38, 38],
		}),
		Publico: L.icon({
			iconUrl: logoPublicas,
			iconSize: [38, 38],
		})
	}

	const CenterMap = ({ position }) => {
		const map = useMap();
		useEffect(() => {
			if (position) {
				map.flyTo(position, 12); // Cambia el centro del mapa con una animación
			}
		}, [position, map]);
		return null;
	};

	const searcher = (e) => {
		setSearch(e.target.value);
	}

	const naturalezaCapi = (e) => {
		console.log("Seleccionaste:", e.target.value)
		setTipoNaturaleza(e.target.value);
	}

	let results = capisDepto.filter((dato) =>
		(tipoNaturaleza === "" || dato.naturaleza.trim().toLowerCase() === tipoNaturaleza.toLowerCase()) &&
		(search === "" || dato.nombre_establecimiento.toLowerCase().includes(search.toLowerCase()))
	);


	return (
		<div className="pt-14 md:pt-10 pb-4 px-4 w-full h-full md:pr-6 md:pl-28">
			<div className="flex flex-col mb-2">
				<div className="flex flex-row w-auto items-center mb-4">
					<Link to="/UbicacionCapis" className="btn btn-return border-4 border-custom-main w-12 h-12">
						<FontAwesomeIcon icon={faArrowLeft} className="text-lg" />
					</Link>
					<p className="text-4xl font-bold text-[#063E5F] text-center pl-3">Localización de centros CAPI</p>
				</div>
				<div className="flex flex-wrap-reverse md:flex-wrap">
					<div className="w-full md:w-4/6">
						<MyMap height="70vh" width="100%" className="map" />
					</div>
					<div className="w-full md:w-2/6">
						<div className="mx-3 flex flex-col w-auto py-5">
							<div className='flex flex-row justify-start w-full mb-4'>
								<select value={tipoNaturaleza} onChange={naturalezaCapi} className="w-1/2 border-2 p-4 text-sm rounded-lg font-normal mr-2">
									<option value="">Naturaleza</option>
									<option value="Patronal">Patronal</option>
									<option value="Privado">Privado</option>
									<option value="Publico">Público</option>
								</select>
								<input type='text' value={search} placeholder='Nombre del CAPI' onChange={searcher} className='w-1/2 border-2 p-4 ml-2 text-sm rounded-lg font-normal' />
							</div>
							<div className='text-center'>
								<table className="w-full">
									<thead>
										{capisDepto.length > 0 ? (
											<tr>
												<th className="border p-2 font-bold bg-custom-cyan">
													Capis Autorizados: <span className="font-normal">{capisDepto[0].departamento}</span>
												</th>
											</tr>
										) :
											<tr>
												<th className="p-2 font-bold bg-white">
													No hay CAPIS en este departamento por el momento
												</th>
											</tr>
										}
									</thead>
									<tbody>
										{results.map((dato, i) => {
											return (
												<tr key={dato.id_autorizacion}>
													<td 
														className="border cursor-pointer bg-white text-blue-500 py-2 transition-colors hover:bg-slate-200"
														onClick={() => getSelectedCapi(dato.id_autorizacion)}
													>
															{dato.nombre_establecimiento}
													</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
				{/* MODAL CON REACT-MODAL */}
				<Modal
					isOpen={isModalOpen}
					onRequestClose={() => setIsModalOpen(false)}
					contentLabel="Detalles del CAPI"
					className="bg-white p-5 rounded-lg shadow-lg w-2/3 mx-auto mt-10"
					overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
				>
					{selectedCapi && (
						<div className='flex flex-row justify-between w-auto'>
							{console.log(JSON.parse(selectedCapi.edades))}
							<div className='w-11/12'>
								<div className='flex flex-row justify-between items-center'>
									<div className="flex flex-col items-center w-2/3">
										<h2 className="text-2xl font-bold text-[#0D7F9F]">{selectedCapi.nombre_establecimiento}</h2>
										<p className='text-sm'>{selectedCapi.departamento}, {selectedCapi.municipio}</p>
									</div>
									<img src={`https://capis-fundemas.ticongle.com/backend/public/${selectedCapi.imagen}`} className="h-auto w-24 mr-4" alt="" />
								</div>
								<hr className='border-2 border-gray-600' />
								<div className='flex flex-row'>
									<div className='m-3'>
										<MapContainer center={[selectedCapi.latitud, selectedCapi.longitud]} zoom={17} className=''>
											<TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />
											<CenterMap position={selectedPosition} />
											<Marker
												key={selectedCapi.id_autorizacion}
												position={[selectedCapi.latitud, selectedCapi.longitud]}
												icon={icons[selectedCapi.naturaleza] || icons.Publico}>
												<Popup>
													{selectedCapi.nombre_establecimiento} <br />
													Tipo: {selectedCapi.naturaleza}
												</Popup>
											</Marker>
										</MapContainer>
									</div>
									<div className='mt-2'>
										<div>
											<h1 className='font-bold text-[#0D7F9F]'>Número de autorización:</h1>
											<p>{selectedCapi.id_autorizacion}</p>
										</div>
										<hr className='border-2 border-[#949191]' />
										<div>
											<h1 className='font-bold text-[#0D7F9F]'>Naturaleza:</h1>
											<p className='uppercase'>{selectedCapi.naturaleza}</p>
										</div>
										<hr className='border-2 border-[#949191]' />
										<div>
											<h1 className='font-bold text-[#0D7F9F]'>Dirección:</h1>
										</div>
										<p>{selectedCapi.calle}, {selectedCapi.colonia}, <br /> {selectedCapi.distrito}, {selectedCapi.municipio}, {selectedCapi.departamento}</p>
									</div>
								</div>
								<hr />
								<div className='flex flex-row justify-between'>
									<div><h1 className='font-bold text-[#0D7F9F]'>Capacidad:</h1>
										<p>{selectedCapi.capacidad} Niños/as</p></div>
									<hr className='border-2 border-[#949191] h-auto' />
									<div><h1 className='font-bold text-[#0D7F9F]'>Matrícula:</h1>
										<p>${selectedCapi.matricula}</p></div>
									<hr className='border-2 border-[#949191] h-auto' />
									<div><h1 className='font-bold text-[#0D7F9F]'>Mensualidad:</h1>
										<p>${selectedCapi.capacidad}</p> </div>
									<hr className='border-2 border-[#949191] h-auto' />

									<div><h1 className='font-bold text-[#0D7F9F]'>Atienden edades:</h1>{JSON.parse(selectedCapi.edades).map((item) => {
										return <p className='text-center'> {item}</p>
									})}</div>
									<hr className='border-2 border-[#949191] h-auto' />
									<div><h1 className='font-bold text-[#0D7F9F]'>Teléfonos:</h1>
										<p>{selectedCapi.telefono_fijo}<br />{selectedCapi.telefono_movil}</p></div>
								</div>
							</div>
							<div>
								<button
									className="m-3 text-white p-4 rounded-full bg-[#E3087F] flex items-center justify-center w-[30px] 2xl:w-[50px] h-[30px] 2xl:h-[50px]"
									onClick={() => setIsModalOpen(false)}
								>
									<FontAwesomeIcon icon={faXmark} className="text-lg 2xl:text-2xl" />
								</button>
							</div>
						</div>
					)}
				</Modal>
			</div>
		</div>
	);
}
export default DetallesDepto;
